export default __webpack_public_path__ + "static/media/icon-drone-failed.8c5c2b67.png";